export default __webpack_public_path__ + "locales/sk/DowngradePlanDialog.json?hash=1c7287fd56c842e3c1407bf46b38b9ef";